import {Injectable} from '@angular/core';
import {LocalStorageService} from './local-storage.service';

@Injectable()
export class CycleService {
    constructor() {
    }

    public setCycle(cycleId: number) {
        localStorage.setItem(LocalStorageService.key.cycleId, cycleId.toString());
    }

    public getCycle() {
        return localStorage.getItem(LocalStorageService.key.cycleId);
    }
}